<template>
    <!-- 下拉菜单组件 -->
    <el-dropdown
    :split-button="splitBtn"
    :type="type"
    :trigger="trigger"
    :hide-on-click="hideClick"
    :size="size"
    :placement="placement"
    :tabindex="tabindex"
    @command="command"
    @click="leftFn"
    >
        <!-- 主体插槽 -->
        <span v-if="!splitBtn">
            {{text}}<VelIcon iconName="el-icon-arrow-down el-icon--right" />
        </span>
        <slot></slot>
        <!-- 下拉列表 -->
        <el-dropdown-menu slot="dropdown">
            <template v-for="(dr,dinx) in dropdownList">
                <el-dropdown-item
                :disabled="dr.disabled"
                :divided="dr.divided"
                :command="dr.command"
                :key="dr.text + dinx"
                >
                    <slot v-if="dr.slot" :name="dr.slot" :row="dr" ></slot>
                    <VelIcon v-else :iconName="dr.icon" :iconText="dr.text" />
                </el-dropdown-item>
            </template>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import VelIcon from '../icon'
export default {
    name:"VelDropDown",
    components:{
        VelIcon
    },
    props:{
        type:String,
        trigger:String,
        text:{
            type:String,
            default:'更多'
        },
        size:String,
        placement:String,
        tabindex:Number,
        isHideClick:Boolean,
        isSplitBtn:Boolean,
        dropdownList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            hideClick:true,
            splitBtn:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isHideClick ? this.hideClick = false : this.hideClick
            this.isSplitBtn ? this.splitBtn = true : this.splitBtn
        },
        command(val){
            this.$emit('command',val)
        },
        leftFn(e){
            this.$emit('leftFn',e)
        }
    }
}
</script>